import { render, staticRenderFns } from "./HelpDeskJira.vue?vue&type=template&id=38c1c5de"
import script from "./HelpDeskJira.vue?vue&type=script&lang=js"
export * from "./HelpDeskJira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports